import { MtTaskComment } from "server/models"

export interface TaskCommentList { [taskId: number]: MtTaskComment[] }

export type TaskCommentValidation = { [key in keyof MtTaskComment]?: string}

export interface TaskCommentState {
    commentList: TaskCommentList
}

export const TASK_COMMENT_LIST = "TASK_COMMENT_LIST"
